import React from "react";
import swal from "sweetalert";
import "../../styles/Components/alert/alert.css";

function hasAlertText(value) {
  if (value == null) return false;
  if (typeof value === "string") return value.trim().length > 0;
  return true;
}

const alert = (title, text, icon, buttons, actionCallback) => {
  if (!hasAlertText(title) && !hasAlertText(text)) return;

  return swal({
    title,
    text,
    icon,
    className: "swalAlert",
    buttons,
    allowOutsideClick: false,
    closeOnClickOutside: false,
  }).then((value) => {
    const callback = actionCallback?.[value];
    if (typeof callback === "function") {
      callback();
    }
    switch (value) {
      case "buyPlan":
        window.location.href = "/pricing-billing/subscription";
        break;
      case "login":
        // localStorage.clear();
        window.location.href = "/auth/login";
        break;
    }
  });
};

export default alert;
